import type { Page } from 'types/page';
import React from 'react';
import Figure from 'components/figure';

export type AffiliateLogoProps = Pick<Page['acf'], 'affiliateLogo'> & {
  affiliateWebsite?: string;
};

const AffiliateLogo: React.FC<AffiliateLogoProps> = ({
  affiliateLogo,
  affiliateWebsite,
}) => {
  if (!affiliateLogo && !affiliateWebsite) {
    return null;
  }

  const Wrapper = affiliateWebsite ? 'a' : 'div';
  const wrapperProps = affiliateWebsite
    ? {
        href: affiliateWebsite,
        target: '_blank',
      }
    : {};

  return (
    <Wrapper
      className="md:justify-self-start justify-self-center"
      {...wrapperProps}
    >
      <Figure
        {...affiliateLogo}
        width={120}
        height={120}
        alt={affiliateLogo.alt}
        className="h-full mix-blend-multiply"
        objectFit="contain"
      />
    </Wrapper>
  );
};

export default AffiliateLogo;
